import PropTypes from 'prop-types';
import { useEffect, useReducer, useCallback, useMemo } from 'react';
// utils
//
import { AuthContext } from './auth-context';
// import { setSession } from './utils.js';
// import axios from '../../utils/axios.js';
// import { HOST_API } from '../../config-global';

// ----------------------------------------------------------------------

// POC BYPASS: Authentication completely disabled for POC testing
// All auth logic commented out and stubbed to always return authenticated state

// ----------------------------------------------------------------------

const initialState = {
  user: {
    id: 'poc-user-123',
    email: 'poc@leaffilter.com',
    username: 'pocuser',
    token: 'poc-mock-token',
  }, // Always authenticated with mock user
  loading: false, // Never loading
};

const reducer = (state, action) => {
  // POC BYPASS: Always return authenticated state regardless of action
  return {
    loading: false,
    user: {
      id: 'poc-user-123',
      email: 'poc@leaffilter.com',
      username: 'pocuser',
      token: 'poc-mock-token',
    },
  };
};

const STORAGE_KEY = 'accessToken';

export function AuthProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);

  const initialize = useCallback(async () => {
    // POC BYPASS: Always initialize as authenticated
    dispatch({
      type: 'INITIAL',
      payload: {
        user: {
          id: 'poc-user-123',
          email: 'poc@leaffilter.com',
          username: 'pocuser',
          token: 'poc-mock-token',
        },
      },
    });
  }, []);

  useEffect(() => {
    initialize();
  }, [initialize]);

  // POC BYPASS: Mock login that always succeeds
  const login = useCallback(async (apiData) => {
    console.log('[POC BYPASS] Mock login called with:', apiData);
    // Simulate successful login without API call
    dispatch({
      type: 'LOGIN',
      payload: {
        user: {
          id: 'poc-user-123',
          email: 'poc@leaffilter.com',
          username: 'pocuser',
          token: 'poc-mock-token',
        },
      },
    });
    return Promise.resolve();
  }, []);

  // POC BYPASS: Mock logout (doesn't actually log out)
  const logout = useCallback(async () => {
    console.log('[POC BYPASS] Mock logout called - staying authenticated');
    // Don't actually log out in POC mode
    return Promise.resolve();
  }, []);

  // POC BYPASS: Always return authenticated state
  const checkAuthenticated = state.user ? 'authenticated' : 'unauthenticated';

  const status = state.loading ? 'loading' : checkAuthenticated;

  const memoizedValue = useMemo(
    () => ({
      user: state.user,
      method: 'jwt',
      loading: state.loading,
      authenticated: true, // Always authenticated
      unauthenticated: false, // Never unauthenticated
      //
      login,
      // register, // Commented out
      logout,
    }),
    [login, logout, state.loading, state.user],
  );

  return <AuthContext.Provider value={memoizedValue}>{children}</AuthContext.Provider>;
}

AuthProvider.propTypes = {
  children: PropTypes.node,
};
